import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/youcam-4-web"
    path="business/services/youcam-4-web"
    element={<AsyncPage />}
  />,
];
